const remedyTypes = ["Tincture", "Capsules & Powder", "Wine", "Infusion", "Decoction", "Syrup", "Infused Oil", "Ointment", "Poultice", "Cream", "Compresses & Lotion", "Juice", "Cold Maceration", "Baths & Skin Wash", "Essential Oil", "Pessaries & Suppositories", "Gargles & Mouthwash", "Steam Inhalation", "Other"]


export {
    remedyTypes
}